import Vue from 'vue'
import App from '@/App'
import router from '@/routes'
import store from '@/store'
import i18n from '@/plugins/i18n'
import api from '@/api'
import FlagIcon from 'vue-flag-icon'

Vue.use(FlagIcon);

Vue.config.productionTip = false;

let config = window.EPPConfig || {translations: {}, language: null, languageMap: {}};

let translations = config.translations || [];
for (let key in translations) {
  if ('langCode' in translations[key] && 'nativeLabel' in translations[key] && 'translations' in translations[key]) {
    i18n.RegisterLanguage(translations[key].langCode, translations[key].nativeLabel, translations[key].translations);
  }
}

i18n.SetActiveLanguage(config.language || null);
i18n.SetLanguageMap(config.languageMap || {});

router.beforeEach((to, from, next) => {
  let user = {
    id: parseInt(store.getters['auth/getUserId']),
    roles: store.getters['auth/isAdmin'] ? ['admin'] : []
  };

  store.commit('setPageTitle', to.meta.title || null);

  let local_actions = to.meta.local_actions || [];
  for (let i in local_actions) {
    local_actions[i].params = to.params;
  }
  store.commit('setLocalActions', local_actions);

  let local_tasks = to.meta.local_tasks || [];
  for (let i in local_tasks) {
    local_tasks[i].params = to.params;
  }
  store.commit('setLocalTasks', local_tasks);

  if (to.meta.access === true) {
    next();
    return;
  }

  if (to.meta.access(user) === false) {
    if (user.id === 0) {
      next({name: 'login'});
    } else {
      next({name: '403'});
    }
    next();
    return;
  }

  next();
});

Vue.filter('t', function () {
  return i18n.T(arguments)
});

Vue.mixin({
  computed: {
    activeLanguage() {
      return store.getters['language/getActiveLanguage']
    }
  },
  watch: {
    'activeLanguage' (to, from) {
      Vue.nextTick(() => this.$forceUpdate())
    }
  }
});

api.setGlobalNoker(error => store.dispatch('messages/httpErrorMessage', error, {root: true}));
api.setPreFlight(() => store.commit('setLoading', true));
api.setPostFlight(() => store.commit('setLoading', false));

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: (h) => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js